import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class FileUploaderService {
  constructor (private http: HttpClient , private api: AppConfig) {
  }

  initializeResponse (data) {
    return this.http.post(this.api.baseUrl + '/uploadService/create-multipart' , data , this.api.jsonTokenHeaders);
  }

  uploadPart (data) {
    return this.http.post(this.api.baseUrl + '/uploadService/upload-part' , data , this.api.jsonTokenHeaders);
  }

  completeMultiPart (data) {
    return this.http.post(this.api.baseUrl + '/uploadService/complete-multipart' , data , this.api.jsonTokenHeaders);
  }
}
